import React from 'react';
import getConfig from 'next/config';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import NImage from 'next/image';
import Background from '/public/static/images/contact_bg.jpg';
import Logo from '/public/static/images/logo.svg';

const LogoRectangle = styled.div`
    width: 272px;
    height: 272px;
    position: absolute;
    margin-top: -12%;
    margin-left: 20px;
    max-width: 272px;
    background: white;
    display: flex;
    border: 1px solid ${({ theme }) => theme.colors.lightBlue};
    :before {
        content: '';
        display: block;
        /* padding-top: 100%; */
    }
    > img {
        bottom: 0;
        left: 0;
        margin: auto;
        right: 0;
        position: absolute;
        top: 0;
    }
    @media (max-width: 992px) {
        left: 50%;
        transform: translateX(-50%);
        margin-left: 0px;
        margin-bottom: 15px;
        max-width: 140px;
        max-height: 140px;
    }
`;

const HeadingCol = styled(Col)`
    @media (max-width: 992px) {
        margin-bottom: 50px;
    }
`;

export const LogoHeadingSection = () => {
    const { name } = getConfig().publicRuntimeConfig;
    return (
        <Row style={{ position: 'relative' }}>
            <HeadingCol span={24}>
                <NImage
                    width={1200}
                    height={303}
                    src={Background}
                    alt={name}
                    style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                />
                <LogoRectangle>
                    <NImage src={Logo} alt={name} style={{ maxWidth: '100%', height: 'auto' }} />
                </LogoRectangle>
            </HeadingCol>
        </Row>
    );
};

export default LogoHeadingSection;
